import { ButtonGroup } from "@components/button";
import styled from "styled-components";

import { VIEW_PADDING_VALUE } from "../../../views/View.styles";


export const ButtonGroupStyled = styled(ButtonGroup)`
    padding: 22px 0 ${VIEW_PADDING_VALUE}px;
`;